import { useState, useEffect } from 'react'

export function useNetwork() {
  const [isOnline, setIsOnline] = useState(() => navigator.onLine)

  useEffect(() => {
    // Essai d'utiliser Capacitor Network si disponible
    let cleanupCapacitor: (() => void) | null = null

    async function tryCapacitorNetwork() {
      try {
        const win = window as Window & {
          Capacitor?: { isNativePlatform?: () => boolean }
        }
        if (!win.Capacitor?.isNativePlatform?.()) return

        const { Network } = await import('@capacitor/network')
        const status = await Network.getStatus()
        setIsOnline(status.connected)

        const handle = await Network.addListener('networkStatusChange', (s) => {
          setIsOnline(s.connected)
        })
        cleanupCapacitor = () => handle.remove()
      } catch {
        // Capacitor Network non disponible — fallback sur les events navigateur
      }
    }

    void tryCapacitorNetwork()

    // Fallback navigateur (toujours actif)
    const onOnline  = () => setIsOnline(true)
    const onOffline = () => setIsOnline(false)
    window.addEventListener('online',  onOnline)
    window.addEventListener('offline', onOffline)

    return () => {
      cleanupCapacitor?.()
      window.removeEventListener('online',  onOnline)
      window.removeEventListener('offline', onOffline)
    }
  }, [])

  return { isOnline }
}
